// File: `app/javascript/controllers/product_module/hotetec.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';

export function initHotetec(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        setSessionVar,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        locale,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    const hotetec_destination = $('#hotetec_destination');
    const hotetec_date_range = $('#hotetec_date_range');
    const hotetec_rooms = $('#hotetec_rooms');

    // Estado inicial
    hotetec_date_range.prop('disabled', true);
    hotetec_rooms.prop('disabled', true);

    hotetec_destination.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: `${location.origin}/${locale.locale}/hoteles_destination`,
            dataType: "json",
            language: "es",
            type: 'GET',
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            processResults: function (data, params) {
                params.page = params.page || 1;
                const result = (data.rows || []).map(elem => ({
                    id: elem[1],
                    text: elem[0]
                }));
                return { results: result };
            }
        }
    }).on('change', function (e) {
        const destino_id = e.target.value || '';
        const destino_text = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerText) || '';

        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', destino_id);
        create_array_for_product('destination_code', destino_id); // si tiene code distinto, ajustar aquí
        create_array_for_product('text_destination', destino_text);

        // habilitar fechas y habitaciones
        hotetec_date_range.prop('disabled', false);
        hotetec_rooms.prop('disabled', false);

        // inicializar flatpickr rango
        flatpickr("#hotetec_date_range", {
            mode: "range",
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disable: date_disabled,
            locale: flatpick_lang,
            disableMobile: "true"
        });

        // limpiar valores previos
        hotetec_date_range.val('');
        hotetec_rooms.val(null).trigger('change');
    });

    // manejar cambio en rango de fechas
    hotetec_date_range.on('change', function (e) {
        const value = e.target.value || '';
        const parts = value.split(flatpick_lang.rangeSeparator);
        if (parts.length > 0 && parts[0].trim() !== '') {
            setSessionVar('from_date', parts[0].trim(), 'add', true, false).then(from => {
                create_array_for_product('from_date', from.value || parts[0].trim());
            });
        }
        if (parts.length > 1 && parts[1].trim() !== '') {
            setSessionVar('to_date', parts[1].trim(), 'add', true, false, 1).then(to => {
                create_array_for_product('to_date', to.value || parts[1].trim());
            });
        }
    });

    // manejar cambio en habitaciones
    hotetec_rooms.on('change', function (e) {
        const rooms = e.target.value || '';
        create_array_for_product('rooms', rooms);
        setSessionVar('hotetec_rooms', rooms, 'add', false).then();
    });
}


/* Antes de dividir */
/*
let hotetec_destination = $('#hotetec_destination');
let hotetec_date_range = $('#hotetec_date_range');
let hotetec_rooms = $('#hotetec_rooms');

hotetec_destination.select2({
    theme: "bootstrap",
    placeholder: I18n.t('global.main.form.select_destiny'),
    ajax: {
        url: `${location.origin}/${locale.locale}/hoteles_destination`,
        dataType: "json",
        language: "es",
        /!*data: function (params) {},*!/
        type: 'GET',
        processResults: function (data, params) {
            let result = [];

            data.rows.map((elem, key) => {
                result.push({
                    id: elem[1], text: elem[0]
                })
            })

            return {
                results: result
            }
        }
    }
}).on('change', function (e) {

})*/
